window.jQuery = window.$ = require('jquery');
var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/wishlistHeart'));
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/footer'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('base/components/countrySelector'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('./components/consentTracking'));
    processInclude(require('./components/menu'));
    processInclude(require('./components/miniCart'));
    processInclude(require('./product/anadirReceta'));
});

require('slick-carousel/slick/slick.min.js');
require('base/thirdParty/bootstrap');
require('base/components/spinner');
